// src/components/AboutUs.js
import React from 'react';
import './AboutUs.css';
import mangaIcon from '../assets/a1.jpg';
import animeIcon from '../assets/a2.jpg';
import musicIcon from '../assets/a3.jpg';
import cosplayIcon from '../assets/a4.jpg';

const AboutUs = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2>JAPAN OTAKU EX</h2>
        <div className="description">
          <p>
            Welcome to the Philippines' most electrifying <strong>Japanese pop-culture expo</strong>! 
            JAPAN OTAKU EX blends high-octane esports energy with the passion of otaku culture.
          </p>
          <p>
            This August 2025, fans unite for a three-day spectacle of cosplay competitions, 
            anime showcases, manga releases, live performances, and community tournaments. 
          </p>
          <p className="highlight">
            <strong>Our mission:</strong> To create a thrilling fusion of esports vibes and otaku spirit, 
            building a vibrant arena for fans and creators to connect.
          </p>
        </div>

        <div className="pillar-grid">
          <div className="pillar card">
            <img src={mangaIcon} alt="Manga" className="pillar-img-glow" />
            <h3>MANGA</h3>
            <p>From shonen jump to indie doujinshi</p>
          </div>
          <div className="pillar card">
            <img src={animeIcon} alt="Anime" className="pillar-img-glow" />
            <h3>ANIME</h3>
            <p>Screenings, merch, and creator talks</p>
          </div>
          <div className="pillar card">
            <img src={musicIcon} alt="Music" className="pillar-img-glow" />
            <h3>MUSIC</h3>
            <p>Anime OSTs to vocaloid performances</p>
          </div>
          <div className="pillar card">
            <img src={cosplayIcon} alt="Cosplay" className="pillar-img-glow" />
            <h3>COSPLAY</h3>
            <p>Competitions and craftsmanship</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
